module.exports = __webpack_public_path__ + "img/payumoney.efdc375c.jpg";